if (!customElements.get("variant-gifts")) {
  class VariantGifts extends HTMLElement {
    connectedCallback() {
      const form = this.closest("product-form");
      if (!form) return;

      this.variantInput = form.querySelector(`form [name="id"]`);

      if (!this.variantInput) return;

      this.variantInput.addEventListener(
        "change",
        this.onVariantChange.bind(this),
      );
      this.onVariantChange();
    }

    onVariantChange() {
      const variantId = this.variantInput.value;

      this.querySelectorAll('input[type="hidden"]').forEach((input) => {
        const isActive = input.hasAttribute(`data-free-gift-${variantId}`);
        input.disabled = !isActive;
        if (isActive) {
          input.setAttribute("name", "items[1][id]");
        } else {
          input.removeAttribute("name");
        }
      });
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    customElements.define("variant-gifts", VariantGifts);
  });
}
